<template>
    <div class="mdl-layout mdl-js-layout mdl-layout--fixed-header">
        <static-header />
        <main class="mdl-layout__content transcript_page">
            <div class="content_wrapper">
                <div class="mdl-grid">
                    <div class="mdl-cell mdl-cell--12-col">
                        
                        <h2>ဝက်ဘ်ဆိုဒ်အသုံးပြုပုံ (အမေးများသော မေးခွန်းများ)</h2>
                        
                        <p>
                        ဝက်ဘ်ဆိုဒ်ရဲ့ ရည်ရွယ်ချက်ဟာ အစည်းအဝေးမှတ်တမ်းတွေကို အလွယ်တကူ ရှာဖွေနိုင်စေဖို့ ဖြစ်တဲ့အတွက် ကိုယ်ရှာဖွေချင်တဲ့ အကြောင်းအရာကို ရိုက်သွင်းပြီး ရှာဖွေမယ်ဆိုရင်တော့ ကိုယ်ရှာဖွေတဲ့ စကားလုံး ပါဝင်တဲ့ အစည်းအဝေးနေ့ရဲ့ မှတ်တမ်းအပြည့်အစုံကို အရေအတွက် များရာမှ နည်းရာသို့ စီပြီး ဖော်ပြပေးသွားမှာ ဖြစ်ပါတယ်။ ဒီလိုရှာဖွေရာမှာ အသုံးဝင်မယ့် ရှာဖွေနည်းအချို့ကိုလည်း မျှဝေပေးလိုက်ပါတယ်။
                        </p>

                        <h2>စာလုံးတစ်လုံးထက်ပိုပြီး ရှာဖွေချင်ရင် ဘယ်လိုရှာမရလဲ။</h2>
                        
                        <p>
                        တစ်လုံးထက်ပိုတဲ့ စကားလုံးတွေနဲ့ ရှာဖွေချင်တယ်ဆိုရင်တော့ Space ခြားပြီး ရှာဖွေနိုင်ပါတယ်။ ဒီလိုဆိုရင်တော့ စာလုံးနှစ်မျိုးလုံး ပါဝင်မှု အများဆုံးကနေ အနည်းဆုံးအထိ စီပြီ ရလဒ်အနေနဲ့ ပြန်လည်ဖော်ပြပေးမှာ ဖြစ်ပါတယ်။ သတိပြုသင့်တာကတော့ ဒီလိုရှာမယ်ဆိုရင် ရှာတဲ့ စာလုံးနှစ်လုံးထဲက တစ်လုံးပဲ ပါဝင်တဲ့ မှတ်တမ်းတွေကိုလည်း ဖော်ပြပေးမှာ ဖြစ်ပါတယ်။ ဥပမာအားဖြင့် [ပညာရေး အစီရင်ခံစာ] လို့ရိုက်ပြီး ရှာမယ်ဆိုရင်တော့ “ပညာရေး” နဲ့ “အစီရင်ခံစာ” စာလုံးနှစ်လုံးတွဲ အများဆုံးပါဝင်တဲ့ မှတ်တမ်းကနေ “ပညာရေး” ဒါမှမဟုတ် “အစီရင်ခံစာ” ဆိုတဲ့ စကားလုံး တစ်လုံးလုံး ပါဝင်တဲ မှတ်တမ်းတွေအထိကို ရှာဖွေပေးမှာ ဖြစ်ပါတယ်။ 
                        </p>

                        <h2>စလုံးအတိအကျ ရှာချင်ရင် ဘယ်လိုရှာရမလဲ။</h2>
                        
                        <p>
                        စကားလုံးအတိအကျကို ရိုက်ပြီး ရှာဖွေချင်တယ်ဆိုရင်တော့ မျက်တောင်အဖွင့်အပိတ် (“ ”) နဲ့ ရှာရမှာ ဖြစ်ပါတယ်။ [“ပညာရေး အစီရင်ခံစာ”] ဆိုပြီး ရိုက်ပြီး ရှာမယ်ဆိုရင်တော့ “ပညာရေး အစီရင်ခံစာ” ဆိုတဲ့ ဖော်ပြချက် အတိအကျကိုပဲ ရှာဖွေပေးမှာ ဖြစ်ပါတယ်။ 
                        </p>  
                        
                        <h2>ပါစေချင်တဲ့စာလုံး/မပါစေချင်တဲ့စာလုံးတွေကို ဘယ်လို ခွဲပြီး ရှာရမလဲ။</h2>
                        
                        <p>
                        ဖော်ပြမယ့် ရလဒ်မှာ ပါစေချင်တဲ့ စာလုံး၊ မပါစေချင်တဲ့ စာလုံး အတိအကျ ရှိတယ်ဆိုရင်တော့ “+/-” ကို အသုံးပြုပြီး ရှာဖွေနိုင်ပါတယ်။ ကိုယ်ဖတ်ချင်တဲ့မှတ်တမ်းမှာ “ပညာရေး” ဆိုတဲ့စာလုံး ပါဝင်ပြီး “သင်ရိုး” ဆိုတဲ့ စာလုံးပါ ပါဝင်စေချင်တယ်ဆိုရင်တော့ [ပညာရေး+သင်ရိုး] လို့ရိုက်ပြီး ရှာရမှာ ဖြစ်ပါတယ်။ ဒါမှမဟုတ် “ပညာရေး” ဆိုတဲ့ စာလုံးပဲ ပါဝင်ပြီး “ကျောင်း” ဆိုတဲ့ စာလုံးမပါဝင်စေချင်ဘူးဆိုရင်တော့ [ပညာရေး-ကျောင်း] လို့ရိုက်ရှာရမှာ ဖြစ်ပါတယ်။ 
                        </p>

                        <h2>လွှတ်တော်ကိုယ်စားလှယ်နာမည်နဲ့ ရှာရင်ရော ရမလား။</h2>
                        
                        <p>
                        လွှတ်တော်ကိုယ်စားလှယ်တွေကိုလည်း အမည်ရိုက်သွင်းပြီး ရှာဖွေနိုင်ပါတယ်။ မှတ်တမ်းတွေဟာ လွှတ်တော်ရဲ့ တရားဝင်မှတ်တမ်းအတိုင်းဖြစ်တဲ့အတွက် မှတ်တမ်းထဲမှာ လွှတ်တော်ကိုယ်စားလှယ်ကို ဘယ်လိုဖော်ပြသလဲ (ဦး၊ စိုင်း၊ စော၊ နန်း၊ နော်၊ မိ၊ ဒေါက်တာ စသည်ဖြင့်) ဆိုတာကို ခန့်မှန်းပြီး ရှာမယ်ဆိုရင် ပိုထိရောက်နိုင်ပါတယ်။
                        </p>


                        <h5>နောက်ထပ်လေ့လာစရာများ</h5>
                        <ul>
                            <li>
                                <router-link :to="{ name: 'about' }">စီမံကိန်းအကြောင်း</router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'info' }">အချက်အလက်ရရှိနိုင်မှု အခြေအနေ</router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'history' }">လွှတ်တော်သမိုင်း မှတ်တမ်း</router-link>
                            </li>
                        </ul>

                    </div>
                </div>
            </div>
            <site-footer></site-footer>
        </main>
    </div>
</template>

<script>

import SiteFooter from '@/components/partials/Footer'
import StaticHeader from '@/components/static_pages/StaticHeader'

export default {
    name: 'FAQ',
    components: {
      'site-footer' : SiteFooter,
      'static-header' : StaticHeader
    },
    data() {
        return {}
    }
}
    
</script>